module.exports = __webpack_public_path__ + "img/fr_fr.0812e04d.png";